import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './CausaNoValidoSelector.module.css'

const CAUSAS = [
  {
    value: 'Prueba Marketing',
    text: 'Prueba Marketing'
  },
  {
    value: 'Duplicado',
    text: 'Duplicado'
  },
  {
    value: 'Spam',
    text: 'Spam'
  },
  {
    value: 'Ubicación inusual',
    text: 'Ubicación inusual'
  },
  {
    value: 'Servicio no relacionado',
    text: 'Servicio no relacionado'
  }
]

const CausaNoValidoSelector = ({ className, name, label, value, onChange }) => (
  <FormControl
    className={`${className} ${css.main}`}
    variant='standard'
    fullWidth
  >
    <InputLabel id={name}>{label}</InputLabel>
    <Select
      name={name}
      labelId={name}
      id={name}
      value={value}
      onChange={onChange}
      label={label}
    >
      {CAUSAS.map(({ value, text }) => (
        <MenuItem key={value} value={value}>
          {text}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default CausaNoValidoSelector
